import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { LetterheadModel } from "../models/letterhead.model";

@Injectable()
export class LetterheadService {

    constructor(private apiService: ApiService) {

    }

    checkIfLetterheadExists(): Observable<boolean> {
        return this.apiService.get<boolean>('letterhead/checkIfExists');
    }

    getLetterhead(): Observable<LetterheadModel> {
        return this.apiService.get<LetterheadModel>('letterhead/get');
    }
}